// Read the time and GPS location a phone saved INSIDE a JPEG photo (EXIF).
// Gallery photos were taken earlier at the address, so their own time and
// location are the true ones — not the time/location of the upload.
// Pure parsing of the file bytes; nothing is sent anywhere.
function readExif(buf) {
  const out = { takenAt: null, gps: null };
  try {
    const v = new DataView(buf);
    if (v.getUint16(0) !== 0xffd8) return out;
    let p = 2;
    while (p + 4 < v.byteLength) {
      const marker = v.getUint16(p);
      if ((marker & 0xff00) !== 0xff00) break;
      const len = v.getUint16(p + 2);
      if (marker === 0xffe1 && v.getUint32(p + 4) === 0x45786966) { parseTiff(v, p + 10, out); break; }
      if (marker === 0xffda) break;
      p += 2 + len;
    }
  } catch (e) { /* not readable — ignore */ }
  return out;
}

function parseTiff(v, t, out) {
  const le = v.getUint16(t) === 0x4949;
  const u16 = (o) => v.getUint16(t + o, le);
  const u32 = (o) => v.getUint32(t + o, le);
  const entries = (ifd) => {
    const n = u16(ifd); const list = [];
    for (let i = 0; i < n; i += 1) {
      const e = ifd + 2 + i * 12;
      list.push({ tag: u16(e), type: u16(e + 2), count: u32(e + 4), valOff: e + 8 });
    }
    return list;
  };
  const ascii = (e) => {
    const off = e.count > 4 ? u32(e.valOff) : e.valOff;
    let str = "";
    for (let i = 0; i < e.count - 1; i += 1) str += String.fromCharCode(v.getUint8(t + off + i));
    return str;
  };
  const rationals = (e) => {
    const off = u32(e.valOff); const r = [];
    for (let i = 0; i < e.count; i += 1) { const d = u32(off + i * 8 + 4); r.push(d ? u32(off + i * 8) / d : 0); }
    return r;
  };
  const ifd0 = entries(u32(4));
  let dt = "";
  const exifPtr = ifd0.find((e) => e.tag === 0x8769);
  if (exifPtr) {
    const ex = entries(u32(exifPtr.valOff));
    const orig = ex.find((e) => e.tag === 0x9003) || ex.find((e) => e.tag === 0x9004);
    if (orig) dt = ascii(orig);
  }
  if (!dt) { const d0 = ifd0.find((e) => e.tag === 0x0132); if (d0) dt = ascii(d0); }
  const m = /^(\d{4}):(\d{2}):(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/.exec(dt);
  if (m) {
    // EXIF time is the phone's local clock time (no zone) — read it as local.
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), Number(m[4]), Number(m[5]), Number(m[6]));
    if (!isNaN(d.getTime()) && d.getFullYear() > 2000) out.takenAt = d.toISOString();
  }
  const gpsPtr = ifd0.find((e) => e.tag === 0x8825);
  if (gpsPtr) {
    const g = entries(u32(gpsPtr.valOff));
    const get = (tag) => g.find((e) => e.tag === tag);
    const latRef = get(0x0001), lat = get(0x0002), lngRef = get(0x0003), lng = get(0x0004);
    if (lat && lng) {
      const dms = (r) => r[0] + (r[1] || 0) / 60 + (r[2] || 0) / 3600;
      let la = dms(rationals(lat)), lo = dms(rationals(lng));
      if (latRef && String.fromCharCode(v.getUint8(t + latRef.valOff)) === "S") la = -la;
      if (lngRef && String.fromCharCode(v.getUint8(t + lngRef.valOff)) === "W") lo = -lo;
      if (Math.abs(la) > 0.0001 && Math.abs(lo) > 0.0001 && Math.abs(la) <= 90 && Math.abs(lo) <= 180) out.gps = { lat: la, lng: lo, accuracy: null, source: "photo" };
    }
  }
}

// Read a File/Blob's EXIF (only JPEGs carry it this way).
async function exifFromFile(file) {
  try {
    if (!file || !/jpe?g/i.test(file.type || file.name || "")) return { takenAt: null, gps: null };
    const buf = await file.slice(0, 256 * 1024).arrayBuffer();
    return readExif(buf);
  } catch (e) { return { takenAt: null, gps: null }; }
}

module.exports = { readExif, exifFromFile };
